import React from 'react'
import { renderToStaticMarkup } from "react-dom/server";
import { withLocalize } from "react-localize-redux";
import Prism from 'prismjs'

class Localized extends React.Component {
    constructor(props) {
        super(props);

        var lang = 'en';
        if (this.props.activeLanguage)
            lang = this.props.activeLanguage.code;

        this.props.initialize({
            languages: [
                { name: "english", code: "en" },
                { name: "french", code: "fr" }
            ],
            options: { renderToStaticMarkup, defaultLanguage: lang }
        });
        this.props.addTranslationForLanguage(this.props.fr, "fr");
        this.props.addTranslationForLanguage(this.props.en, "en");
    }

    componentDidMount() {
        Prism.highlightAll();
    }

    render() {
        return (
            <>
                {this.props.children}
            </>
        );
    }
}

export default withLocalize(Localized)